import { render, staticRenderFns } from "./AdditionalInfoclient.vue?vue&type=template&id=6803135e&"
import script from "./AdditionalInfoclient.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoclient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports